import {
  applyMiddleware, createStore, Store, compose,
} from "redux";
import createSagaMiddleware, { Task, SagaMiddleware } from "redux-saga";
import rootReducer from "./rootReducer";
import rootSaga from "./rootSaga";

// Define Global Dispatch Type
declare global {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let dispatch: any;
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: (...args: any[]) => any;
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export type ConfigureStoreType = {
  store: Store;
  sagaMiddleware: SagaMiddleware;
  sagaTask: Task;
};

function configureStore(preloadedState = {}): ConfigureStoreType {
  const sagaMiddleware = createSagaMiddleware();
  const middlewares = [sagaMiddleware];
  const middlewareEnhancer = applyMiddleware(...middlewares);
  const enhancers = [middlewareEnhancer];
  const composedEnhancers = composeEnhancers(...enhancers);

  const store = createStore(rootReducer, preloadedState, composedEnhancers);

  const sagaTask = sagaMiddleware.run(rootSaga);

  // Assign to global for request.ts compatibility
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  (global as any).dispatch = store.dispatch;

  return {
    store,
    sagaMiddleware,
    sagaTask,
  };
}

export default configureStore;
